import { offlineDb } from './offlineDb';
import { newClientOpId } from './ids';
import { notifyOfflineStatus } from './network';

export const OUTBOX_MAX_RETRIES = 8;

export async function enqueueMutation(item) {
  const row = {
    id: item.id || newClientOpId(),
    clientOpId: item.clientOpId || item.id || newClientOpId(),
    table: item.table,
    op: item.op,
    payload: item.payload || {},
    match: item.match || null,
    preserveColumns: item.preserveColumns || [],
    source: item.source || 'generic',
    createdAt: item.createdAt || Date.now(),
    retries: item.retries || 0,
    status: 'pending',
    lastError: '',
  };
  await offlineDb.outbox.put(row);
  notifyOfflineStatus({ pending: true });
  return row;
}

export async function listPendingOutbox() {
  try {
    const rows = await offlineDb.outbox
      .where('status')
      .anyOf(['pending', 'failed'])
      .toArray();
    return rows.sort((a, b) => (a.createdAt || 0) - (b.createdAt || 0));
  } catch {
    return [];
  }
}

export async function countPendingOutbox() {
  try {
    return await offlineDb.outbox
      .where('status')
      .anyOf(['pending', 'failed'])
      .count();
  } catch {
    return 0;
  }
}

export async function markOutboxSyncing(id) {
  await offlineDb.outbox.update(id, { status: 'syncing' });
}

export async function markOutboxDone(id) {
  await offlineDb.outbox.delete(id);
}

export async function markOutboxFailed(id, error, retries) {
  const nextRetries = Number(retries) || 0;
  const status = nextRetries >= OUTBOX_MAX_RETRIES ? 'failed' : 'pending';
  await offlineDb.outbox.update(id, {
    status,
    retries: nextRetries,
    lastError: String(error?.message || error || 'Sync failed'),
  });
}

export async function resetFailedOutbox() {
  const rows = await offlineDb.outbox.where('status').equals('failed').toArray();
  await Promise.all(rows.map((row) => offlineDb.outbox.update(row.id, {
    status: 'pending',
    retries: 0,
    lastError: '',
  })));
  notifyOfflineStatus({ retry: true });
}

export async function hasPendingOutbox() {
  return (await countPendingOutbox()) > 0;
}
